import { Path as PathParser } from "path-parser";

export default class Route extends PathParser {}
